var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"OurTab",staticClass:"tab",class:_vm.tabClasses,attrs:{"data-cy":_vm.dataCy},on:{"click":_vm.onClickSetValue}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.label)+" ")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }